import { basket_update_timestamp } from "../../../data/other_constants"
import { api } from "../../Shared/methods/ajax/axios_instance"

export default (basket_items) => {
  // Set last update to basket
  window.localStorage.setItem(basket_update_timestamp, new Date().getTime())

  return api.post("validate_basket", basket_items)
}
